export const createEmptyPagination = () => ({
    results: [],
    count: 0,
    next: null,
    previous: null,
})
